import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalAccountsService } from "services/ClientPortalAccountsService";
import { PLInvoiceChargeModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  TransactionInvoices: new PLInvoiceChargeModel(),
  Loading: false,
};

export const TransactionInvoicesTableSlice = createSlice({
  name: "TransactionInvoicesTable",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllInvoicesForTransaction.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getAllInvoicesForTransaction.fulfilled, (state, action) => {
        state.TransactionInvoices = action.payload;
        state.Loading = false;
      })
      .addCase(getAllInvoicesForTransaction.rejected, (state) => {
        state.TransactionInvoices = new PLInvoiceChargeModel();
        state.Loading = false;
      });
  },
});

export const getAllInvoicesForTransaction = createAsyncThunk<PLInvoiceChargeModel, { transactionID: string }>(
  "TransactionInvoicesTableSlice/getAllInvoicesForTransaction",
  async ({ transactionID }) => {
    const accountsService = container.get<IClientPortalAccountsService>(SERVICE_TYPES.ClientPortalAccountsService);
    return await accountsService.getAllInvoicesForTransaction(transactionID);
  }
);

export const downloadChargeFilePDF = createAsyncThunk(
  "TransactionInvoicesTableSlice/downloadChargeFilePDF",
  async (chargeFileID: string) => {
    const accountsService = container.get<IClientPortalAccountsService>(SERVICE_TYPES.ClientPortalAccountsService);
    return await accountsService.downloadChargeFilePDF(chargeFileID);
  }
);

export const selectTransactionInvoices = (state: RootState) => {
  return state.transactionInvoicesTable.TransactionInvoices;
};

export const selectLoadingTransactionInvoices = (state: RootState) => {
  return state.transactionInvoicesTable.Loading;
};

export default TransactionInvoicesTableSlice.reducer;
